/**
 * Aspect to help track down which properties in a model are invalid
 * @param {Object} currentVmNode
 * @param {String} pathFromRoot
 * @param {Array} errorPathsArray
 * @returns {Array}
 */
function failingPropertiesReducer(currentVmNode, pathFromRoot, errorPathsArray) {
    if (!currentVmNode || currentVmNode.aspects.subtreeValid) {
        return errorPathsArray;
    }
    var valueType = currentVmNode._metadataInfo.valueType;
    if (valueType.isPrimitive || valueType.typeInfo && valueType.typeInfo.metaType.isTypelist) {
        if (!currentVmNode.aspects.valid) {
            errorPathsArray.push(pathFromRoot);
        }
    } else if (valueType.isCollection) {
        currentVmNode.children.forEach(function (vmChildNode, idx) {
            return failingPropertiesReducer(vmChildNode, pathFromRoot + '[' + idx + ']', errorPathsArray);
        });
    } else if (valueType.isClass || !currentVmNode._parent) {
        var props = currentVmNode._metadataInfo.valueType.typeInfo.properties;
        props.forEach(function (prop) {
            return failingPropertiesReducer(currentVmNode[prop.jsProperty], pathFromRoot + '.' + prop.jsProperty, errorPathsArray);
        });
    }
    return errorPathsArray;
}

export default {
    'getAspectProperties': function getAspectProperties(currentViewModelNode, currentMetadataNode, ancestorChain) {
        if (ancestorChain.parent) {
            // only add this aspect to the root object
            return undefined;
        }
        return {
            'invalidChildProperties': {
                'get': function get() {
                    return failingPropertiesReducer(currentViewModelNode, '', []);
                }
            }
        };
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-js/aspects/DebugInvalidChildProperties.js
// module id = 937
// module chunks = 0